import { createAction, props } from '@ngrx/store';
import { Organization } from '@core/objects/organization';
import { HttpErrorResponse } from '@angular/common/http'; // Make sure to import this

export const updateOrganization = createAction(
    '[Organization-Settings] Update Organization',
    props<{ name: string }>()
);

export const updateOrganizationSuccess = createAction(
    '[Organization-Settings] Update Organization Success',
    props<{ organization: Organization }>()
);

export const updateOrganizationError = createAction(
    '[Organization-Settings] Update Organization Error',
    props<{ error: HttpErrorResponse }>() // Include error details in the payload
);

export const uploadLogo = createAction(
    '[Organization-Settings] Upload Logo',
    props<{ fileId: string, options: object }>()
);

export const uploadLogoSuccess = createAction(
    '[Organization-Settings] Upload Logo Success',
    props<{ response: any }>()
);

export const uploadLogoError = createAction(
    '[Organization-Settings] Upload Logo Error',
    props<{ error: HttpErrorResponse }>() // Include error details in the payload
);

export const deleteLogo = createAction(
    '[Organization-Settings] Delete Logo'
);

export const deleteLogoSuccess = createAction(
    '[Organization-Settings] Delete Logo Success',
    props<{ response: any }>()
);

export const deleteLogoError = createAction(
    '[Organization-Settings] Delete Logo Error',
    props<{ error: HttpErrorResponse }>() // Include error details in the payload
);

// clear errors
export const clearLogoFailures = createAction(
    '[Organization-Settings] - Clear errors for actions');